import React from 'react';
import Copyright from './Copyright';
import ScrollTop from './ScrollTop';
import FooterOne from './footer';

const TheFooter = () => {
    return (
        <>
            <div className="footer-style-2">
                <FooterOne />
                <Copyright />
            </div>
            <ScrollTop />
        </>
    );
};
export default TheFooter;
